import styled from 'styled-components';
import { colors } from '../common/styles';

const BodyBox = styled.div`
  // overflow-y: auto;
  // height: -webkit-fill-available;
  // overflow-x: hidden;
  // // height: 358px;

  // ::-webkit-scrollbar {
  //   width: 2px;
  // }

  // /* Handle */
  // ::-webkit-scrollbar-thumb {
  //   background: #c2c2ce;
  //   border: 1px solid #c2c2ce;
  // }
`;

/* Online Screen Css Start*/

const OnlineHeader = styled.div`
  padding: 14px 15px;
  display: flex;
  align-items: center;
  background: #f9fafc;
  color: #1e67ee;

  h6 {
    font-size: 15px;
    font-weight: 400;
    margin-bottom: 0px;
    margin-top: 0px;
  }
`;

const OnlineCallBox = styled.div`
  background: ${colors.colorWhite};
  color: var(--black);
  padding: 1.5rem;
  display: flex;
  align-items: center;
  border-radius: 9px;
  padding: 10px 14px;
  margin: 0.6rem;

  .dialInputButton {
    background: #03378c;
    color: ${colors.colorWhite};
    border-radius: 10px;
    font-size: 12px;
    font-weight: 400;
    border: none;
    outline: none;
    padding: 6px 15px;
    margin-left: 0.75rem;
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #1a1848;
    opacity: 1;
    /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #1a1848;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #1a1848;
  }

  ::-webkit-scrollbar {
    width: 2px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #c2c2ce;
  }
`;
const RecentCallBox = styled.div`
  overflow-y: auto;
  height: -webkit-fill-available;
  overflow-x: hidden;
  height: 204px;

  ::-webkit-scrollbar {
    width: 2px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #c2c2ce;
    border: 1px solid #c2c2ce;
  }
`;
/* Online Screen Css End*/

const MainBox = styled.div`
  bottom: 0;
  width: 25%;
  min-width: 400px;
  height: 470px;
  background: ${colors.colorCoreLGray};
  position: fixed;
  border-radius: 9px 9px 0px 0px;
  box-shadow: 0 2px 4px rgb(15 34 58 / 12%);
  right: 3%;
  border: none;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
`;
const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 15px;
  background: ${colors.colorWhite};
  border-radius: 9px 9px 0px 0px;

  h6 {
    font-size: 14px;
    margin: 0;
  }

  .iconCircle i {
    color: ${colors.colorCoreGreen};
    font-size: 9px;
    margin-right: 9px;
  }
  .iconCircleOffline i {
    color: ${colors.colorCoreRed};
    font-size: 9px;
    margin-right: 9px;
  }

  .logo {
    margin: 0px;
    width: 100%;
    text-transform: uppercase;
  }
  .close {
    color: #9b9b9d;
  }
`;
const BodyClass = styled.div`
  background: ${colors.colorWhite};
  margin: 0;
  border-radius: 0px;
  padding: 12px 15px 0px;
  display: block;

  .col-md-6 {
    padding-left: 8px;
    padding-right: 8px;
    margin-bottom: 15px;
  }
`;
const InputBox = styled.div`
  position: relative i {
    position: absolute;
    right: 13px;
    top: 10px;
    color: #ced4da;
  }

  input {
    height: 35px;
    background-color: #f9fafc;
    width: 100%;
    border: 1px solid #e9f1ff;
    border-radius: 8px;
    font-size: 12px;
    padding: 7px;
    color: #8a8a8a;
    outline: none;
  }

  input:focus {
    background-color: #eeeeee69;
    box-shadow: none;
    border-color: #eee;
  }

  input::-webkit-input-placeholder {
    color: #8a8a8a;
    font-size: 12px;
  }
`;
const OverflowClass = styled.div`
  overflow-y: auto;
  height: -webkit-fill-available;
  overflow-x: hidden;
  height: 310px;

  ::-webkit-scrollbar {
    width: 2px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #c2c2ce;
    border: 1px solid #c2c2ce;
  }
`;

const DialBoxCall = styled.div`
  background: #ffffff;
  padding: 20px;
`;

const DialInput = styled.div`
  width: 100%;
  background: #e9f1ff;
  border-radius: 9px;
  margin-right: 25px;

  i {
    margin-left: 1rem;
  }

  .blur {
    color: #858487;
    font-size: 14px;
  }

  .fontClass {
    font-size: 14px;
    font-weight: 400;
  }

  input {
    border: 0;
    border-radius: 9px;
    outline: none;
    background: #e9f1ff;
    font-size: 12px;
    padding: 6px 10px;
    color: #1a1848;
    font-weight: 500;
    width: 100%;
  }
`;
const CircleCall = styled.div`
  width: 41px;
  height: 40px;
  border-radius: 9px;
  background: #e9f1ff;
  text-align: center;

  img {
    margin-top: 12px;
  }
`;
const AddAgent = styled.div`
  font-size: 11px;
  letter-spacing: 0.22px;
  color: #858487;

  p {
    margin-bottom: 0px;
  }
`;
const AgentListBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  h6 {
    color: #1a1848;
    letter-spacing: 0.3px;
    font-size: 14px;
    font-weight: 400;
    width: 75%;
    margin-left: 1.5rem;
    margin-bottom: 0px;
    margin-top: 0px;
  }
  span {
    font-size: 11px;
    color: #303030;
    text-align: -webkit-center;
  }
`;

const ProfileBody = styled.div`
  background: ${colors.colorWhite};
  display: block;
  padding: 10px 14px;
  border-radius: 9px 9px 9px 9px;
  align-items: center;
  text-align: center;

  h6 {
    font-weight: 600;
    font-size: 16px;
    color: ${colors.colorCoreBlack};
  }

  button {
    background: none;
    font-size: 13px;
    padding: 2px 15px;
    border: 1px solid #c2c2ce;
    border-radius: 5px;
    color: #858487;
  }
`;

const BodyInner = styled.div`
  border-radius: 9px;
  padding: 5px 14px;
  margin: 0.6rem;
  background: ${colors.colorWhite};
  display: flex;
  align-items: center;
`;

const BodyInnerClass = styled.div`
  display: block;
  margin-top: 0px;
  border-radius: 9px;
  padding: 10px 14px;
  margin: 0.6rem;
  background: ${colors.colorWhite};

  .inner {
    display: flex;
    width: 100%;
  }
  .select-tag {
    width: 220px;
    margin-left: 10px;
  }

  hr {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;
const InnerBody = styled.div`
  // width: 100%;

  .blur {
    color: #858487;
    font-size: 14px;
  }
  .ml2 {
    margin-left: 1rem;
  }
  .fontClass {
    font-size: 14px;
    font-weight: 400;
  }
`;

const ProfileInner = styled.div`
  width: 100%;

  .blur {
    color: #858487;
    font-size: 14px;
  }
  .ml2 {
    margin-left: 1rem;
  }
  .fontClass {
    font-size: 14px;
    font-weight: 400;
  }
`;

const TeamDropDown = styled.div`
  font-size: 14px;
  font-weight: 500;
  width: 220px;
  margin-left: 20px;

  .dropdown-select {
    display: flex;
    cursor: pointer;
  }

  .dropdown-toggle::after {
    margin-top: 8px;
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: '';
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }

  .dropdown-menu {
    min-width: 31rem;
    top: 215px !important;
    padding: 1rem 1rem;
    border: none;
    box-shadow: 0px 3px 6px #00000029;
    overflow-y: auto;
    height: 190px;
    margin: 0px 11px 5px 14px;
  }

  .dropdown-menu.show {
    display: block;
  }

  .dropdown-menu a {
    border-bottom: 1px solid #f5f4f7;
    padding: 7px 0px;
    font-size: 14px;
    display: block;
    text-align: left;
    color: ${colors.colorBlack};
    text-decoration: none;
    font-weight: 400;
  }

  .dropdown-menu a:hover {
    background: none;
    color: ${colors.colorCoreBlack};
  }

  .dropdown-menu a:last-child {
    border-bottom: none;
  }
`;

const FooterBox = styled.div`
  background: ${colors.colorWhite};
  padding: 1rem 1rem 1rem 1rem;
  font-size: 18px;
  height: 50px;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 67px;
  margin-top: 5px;
  width: 100%;

  .row {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .col {
    text-align: center;
    padding: 0.25rem;
  }

  .activeIcon {
    background: transparent
      linear-gradient(91deg, #4c83f2 0%, #3263c5 44%, #2c336d 100%);
    border-radius: 50px;
    width: 36px;
    height: 36px;
    color: ${colors.colorWhite};
    margin: auto;
    padding: 3px;
  }
`;

export {
  BodyBox,
  RecentCallBox,
  OverflowClass,
  DialBoxCall,
  OnlineHeader,
  OnlineCallBox,
  DialInput,
  CircleCall,
  AddAgent,
  AgentListBox,
  BodyClass,
  InputBox,
  HeaderBar,
  MainBox,
  ProfileBody,
  BodyInner,
  InnerBody,
  TeamDropDown,
  BodyInnerClass,
  FooterBox,
  ProfileInner
};



// WEBPACK FOOTER //
// src/dialpad/components/layout/style.js